import { render, staticRenderFns } from "./JaicDialog.vue?vue&type=template&id=246afb5c"
import script from "./JaicDialog.vue?vue&type=script&lang=js"
export * from "./JaicDialog.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/scss/pages/setting.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports